import React from "react";
import "./style.scss";
import classNames from "classnames";
import { BodyText } from "../../elements";
import { getOverallSettingsClasses } from "../../utils/siteUtils";

const Declare = props => {
  const { fields, rendering } = props;
  const { overlineText, body } = fields;

  const rootClasses = classNames("declare", "grid", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className={"declare__main"}>
        <BodyText className={"declare__main-overline"} html={overlineText} />
        <BodyText className={"declare__main-body"} html={body} />
      </div>
    </div>
  );
};
export default Declare;
